// extracted by mini-css-extract-plugin
export default {"toggle":"LanguageToggle_toggle__t2qOf","button":"LanguageToggle_button__LkS3g","abbr":"LanguageToggle_abbr__ztAbF","buttonActive":"LanguageToggle_buttonActive__F92M0"};